<template>
  <q-input
    ref="qInput"
    dense
    outlined
    v-model="text"
    :type="type"
    :mask="mask"
    :maxlength="maxlength"
    :placeholder="placeholder"
    :readonly="disabled"
    :clearable="clearable"
    clear-icon="mdi-close"
    @blur="onBlur ? onBlur($event) : undefined"
    @keypress="onKeypress ? onKeypress($event) : undefined"
    @keyup.enter="onKeyEnter ? onKeyEnter($event) : undefined"
    hide-bottom-space
    :input-class="inputClass"
    :bg-color="bgColor"
    :color="errorColor"
    :class="['bg-white myFieldText' , className]"
    :prefix="prefix"
    :debounce="debounce"
    :autogrow="autogrow"
    :rules="rules"
    :hint="hint"
    :counter="counter"
  >
    <template
      v-if="$scopedSlots['prepend']"
      #prepend="props"
    >
      <slot
        name="prepend"
        :props="props"
      />
    </template>
    <template
      v-if="$scopedSlots['append']"
      #append="props"
    >
      <slot
        name="append"
        :props="props"
      />
    </template>
  </q-input>
</template>

<script>
export default {
  props: {
    hint: {},

    value: {
      type: String
    },

    rules: {},

    bgColor: {
      type: String,
      default: 'white'
    },

    state: {
      type: Object
    },

    placeholder: {
      type: String
    },

    type: {
      type: String,
      default: 'text'
    },

    mask: {
      type: String,
      default: ''
    },

    prefix: {
      type: String,
      default: ''
    },

    onBlur: {
      type: Function
    },

    onKeypress: {
      type: Function
    },

    onKeyEnter: {
      type: Function
    },

    disabled: {
      type: Boolean,
      default: false
    },

    className: {
      type: String
    },

    inputClass: {
      type: String
    },

    debounce: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 255
    },
    autogrow: {
      type: Boolean,
      default: false
    },

    counter: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      text: forceStr(this.value)
    }
  },

  computed: {
    errorColor () {
      const hasError = Boolean(String((this.state && this.state.dirty) || this.error ? this.error || this.state.error || '' : '').trim())
      return hasError ? 'red-8' : undefined
    }
  },

  watch: {
    text (text) {
      if (isEqual(text, this.value)) return
      this.$emit('input', forceStr(text))
    },

    value (value) {
      if (isEqual(this.text, value)) return
      this.text = forceStr(value)
    }
  }
}

const forceStr = (val) => String(val || '')
const isEqual = (source, target) => forceStr(source) === forceStr(target)
</script>
